import $ from 'jquery';
import { globalSematics } from '../../scripts/config';
import { initPopup } from '../../scripts/initPopup';

const semantics = {
    'iconClass': 'info-tooltip',
    'iconSelector': '.delivery-info-v1 .cart-list__hint.info-tooltip',
    'brandAttribute': 'data-vendor-id',
    'tooltipContentAttribute': 'data-tooltip-content',
};

$(function() {

    var deliveryInfoV1 = new DeliveryInfoV1();
    deliveryInfoV1.subscribe();
    
});

class DeliveryInfoV1
{
    constructor() {
    }

    /**
     * @param {JQuery} el
     */
    showInfo(el) {
        
        const self = this;

        let brandId = el.attr(semantics.brandAttribute);
        
        let popupStackCache = $(globalSematics.popupStackCacheSelector);
        let cacheId = 'delivery-info-v1-' + brandId;
        const config = initPopup.prototype.getConfig(`#${cacheId}`, {});

        if (!popupStackCache.find(`#${cacheId}`).length) {
            $.ajax({
                url: '/op/delivery/as-json',
                method: 'get',
                data: {
                    brandId: brandId,
                },
                success: function (data) {
                    popupStackCache.append('<div class="detail-delivery__popup popup js-popup js-delivery-popup mfp-hide _scrollable" id="' + cacheId + '"></div>');
                    popupStackCache.find(`#${cacheId}`).html(data.data);
                    $.magnificPopup.open(config);
                },
                error: function(data) {
                    $.magnificPopup.open(
                        $('<div class="detail-delivery__popup popup js-popup js-delivery-popup mfp-hide _scrollable">').html(
                            `<p>Упс! На сервере случилась небольшая проблема,\
                            мы уже оповещены и работаем над ней.<br/>\
                            Пожалуйста, попробуйте еще раз позже.</div>`
                        )
                    );
                }
            });
        } else {
            $.magnificPopup.open(config);
        }
    }

    subscribe() {

        const self = this;

        $('body').on('click', semantics.iconSelector, function(e) {
            e.preventDefault();
            let el = $(e.target);
            if (!el.hasClass(semantics.iconClass)) {
                el = el.closest(`${semantics.iconSelector}`);
            }
            self.showInfo(el);
        });

    }    
}